$flagHeight: 15px !default;
$flagWidth: 20px !default;
$flagPadding: 8px !default;

@use '../../../../../node_modules/intl-tel-input/src/css/sprite.scss';

.iti__flag {
  height: $flagHeight;
  box-shadow: 0px 0px var(--p-size-static-0125) 0px var(--s-color-border-default);
  background-repeat: no-repeat;
  // empty state
  background-color: var(--b-color-neutral-default);
  background-position: $flagWidth 0;
  background-size: 5652px 15px;
}

:host {
  display: block;
  position: relative;

  // Default variables

  /** @prop --phone-input-border-width: Set the border width of the phone input. */
  --phone-input-border-width: var(--p-size-static-0125);

  /** DEPRECATED: --border-width is kept for backwards compatibility, but will be removed by April 2024 */
  --border-width: var(--phone-input-border-width);

  /** @prop --phone-input-line-height: Set the line height of the phone input. */
  --phone-input-line-height: var(--p-size-dynamic-300);

  /** DEPRECATED: --line-height is kept for backwards compatibility, but will be removed by April 2024 */
  --line-height: var(--phone-input-line-height);

  // Expanded variables
  /** @prop --phone-input-padding-top: Set the top padding of the phone input. */
  --phone-input-padding-top: 14px;

  /** DEPRECATED: --padding-top is kept for backwards compatibility, but will be removed by April 2024 */
  --padding-top: var(--phone-input-padding-top);

  /** @prop --phone-input-padding-right: Set the right padding of the phone input. */
  --phone-input-padding-right: var(--p-size-static-100);

  /** DEPRECATED: --padding-right is kept for backwards compatibility, but will be removed by April 2024 */
  --padding-right: var(--phone-input-padding-right);

  /** @prop --phone-input-padding-bottom: Set the bottom padding of the phone input. */
  --phone-input-padding-bottom: 14px;

  /** DEPRECATED: --padding-bottom is kept for backwards compatibility, but will be removed by April 2024 */
  --padding-bottom: var(--phone-input-padding-bottom);

  /** @prop --phone-input-padding-left: Set the left padding of the phone input. */
  --phone-input-padding-left: var(--p-size-static-100);

  /** DEPRECATED: --padding-left is kept for backwards compatibility, but will be removed by April 2024 */
  --padding-left: var(--phone-input-padding-left);

  // --margin-top: var(--p-size-static-0125);

  /** @prop --phone-input-margin-top: Set the top margin of the phone input. */
  --phone-input-margin-top: var(--s-size-border-width-default);

  /** DEPRECATED: --margin-top is kept for backwards compatibility, but will be removed by April 2024 */
  --margin-top: var(--phone-input-margin-top);

  /** @prop --phone-input-margin-right: Set the right margin of the phone input. */
  --phone-input-margin-right: var(--s-size-border-width-default);

  /** DEPRECATED: --margin-right is kept for backwards compatibility, but will be removed by April 2024 */
  --margin-right: var(--phone-input-margin-right);

  /** @prop --phone-input-margin-bottom: Set the bottom margin of the phone input. */
  --phone-input-margin-bottom: var(--s-size-border-width-default);

  /** DEPRECATED: --margin-bottom is kept for backwards compatibility, but will be removed by April 2024 */
  --margin-bottom: var(--phone-input-margin-bottom);

  /** @prop --phone-input-margin-left: Set the left margin of the phone input. */
  --phone-input-margin-left: var(--s-size-border-width-default);

  /** DEPRECATED: --margin-left is kept for backwards compatibility, but will be removed by April 2024 */
  --margin-left: var(--phone-input-margin-left);

  /** @prop --phone-input-border-color: Set the border color of the phone input. */
  --phone-input-border-color: var(--s-color-border-default);

  /** @prop --phone-input-border-color-hover: Set the border color of the phone input on hover. */
  --phone-input-border-color-hover: var(--s-color-outline-default);

  /** @prop --phone-input-border-color-error: Set the border color of the phone input for error states. */
  --phone-input-border-color-error: var(--s-color-border-error);

  /** @prop --room-for-select: Give the Input extra padding to make room for the Select. */
  --room-for-select: 105px;

  /** @prop --phone-input-list-countries-length: Set the number of countries shown in the list when it is open. */
  --phone-input-list-countries-length: 4.5;

  /** DEPRECATED: --list-countries-length is kept for backwards compatibility, but will be removed by April 2024 */
  --list-countries-length: var(--phone-input-list-countries-length);

  // Calculated variables
  // List height is based on the padding of the padding of the anchor-select-item component + lineheight and a single border times the amount of countries we want shown.
  /** @prop --phone-input-list-height: Set the height of the list in the phone input. */
  --phone-input-list-height: calc(
    var(--phone-input-list-countries-length) * (var(--p-size-dynamic-150) - var(--phone-input-border-width) + var(--phone-input-line-height) + var(--p-size-dynamic-150))
  );

  /** DEPRECATED: --list-height is kept for backwards compatibility, but will be removed by April 2024 */
  --list-height: var(--phone-input-list-height);

  /** @prop --phone-input-max-width: Set the max width of the phone input. */
  --phone-input-max-width: 328px;

  // --width: calc(330px - var(--phone-input-border-width) * 2 - var(--phone-input-padding-left));
  /** @prop --phone-input-width: Set the width of the phone input. */
  --phone-input-width: calc(330px - var(--phone-input-border-width) * 2 - var(--phone-input-custom-padding-left));

  /** DEPRECATED: --width is kept for backwards compatibility, but will be removed by April 2024 */
  --width: var(--phone-input-width);

  max-width: var(--phone-input-max-width);
}

.anchor-c-phone {
  &.focused {
    --phone-input-margin-top: var(--p-size-static-025);
    --phone-input-margin-right: var(--p-size-static-025);
    --phone-input-margin-bottom: var(--p-size-static-025);
    --phone-input-margin-left: var(--p-size-static-025);
  }
  &__flag-container {
    z-index: 1;
    margin-top: 0;
    &.open {
      z-index: 2;
      .anchor-c-phone__country-list {
        display: block;
      }
    }
  }
  &__selected-dialcode {
    color: currentColor;
    display: inline;
    font-family: var(--s-font-family-paragraph);
  }
  &__country-list {
    display: none;
    height: var(--phone-input-list-height);
    overflow-y: scroll;
    position: absolute;
    border-top: var(--phone-input-border-width) solid var(--phone-input-border-color);
    border-bottom: var(--phone-input-border-width) solid var(--phone-input-border-color);
    ::part(select-item) {
      border-top-width: 0;
    }
  }
  &__country-list-item {
    --border-color: var(--s-color-border-divider);
  }
  .anchor-c-input {
    --input-padding-left: var(--room-for-select);
    --border-color: var(--phone-input-border-color);
    --input-border-width: var(--phone-input-border-width);
    --border-color-hover: var(--phone-input-border-color-hover);
    --border-color-error: var(--phone-input-border-color-error);
  }
}

.selected-flag {
  color: var(--s-color-text-default);
  padding-top: calc(var(--phone-input-padding-top));
  padding-right: var(--phone-input-padding-right);
  padding-bottom: var(--phone-input-padding-bottom);
  padding-left: calc(var(--phone-input-padding-left) + var(--p-size-static-0125) - var(--phone-input-margin-left));
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  border-width: 0;
  border-right: var(--phone-input-border-width) solid var(--phone-input-border-color);
  background-color: var(--color-background-variant-primary);
  height: calc(3rem - var(--phone-input-margin-top) - var(--phone-input-margin-bottom));
  box-sizing: border-box;
  &:focus-visible {
    outline: none;
  }
  &:hover {
    --phone-input-border-color: var(--phone-input-border-color-hover);
  }
  .iti__flag-box {
    margin-right: var(--p-size-static-100);
  }
  .iti__dial-code {
    margin-right: var(--p-size-static-050);
  }
}

.hover {
  --phone-input-border-color: var(--phone-input-border-color-hover);
}

.disabled {
  background: var(--s-color-background-default-disabled);
  border-color: var(--s-color-border-divider);
  color: var(--s-color-text-disabled);
}
.warning {
  border-color: var(--s-color-border-error);
}
.error {
  --phone-input-margin-top: var(--p-size-static-025);
  --phone-input-margin-right: var(--p-size-static-025);
  --phone-input-margin-bottom: var(--p-size-static-025);
  --phone-input-margin-left: var(--p-size-static-025);
  --number-input-border-color: var(--phone-input-border-color-error);
}
